export default __webpack_public_path__ + "static/media/boy.1d12f0f9.svg";